module.exports = __webpack_public_path__ + "img/download.ca0c1bdb.svg";